import * as classNames from "classnames";
import IDream from "motw_core/Entity/IDream";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { IAttributeMapRecord } from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/IAttributeMapRecord/IAttributeMapRecord";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import * as styles from "../DreamAttributeIcon.css";

export const attributeMap: IAttributeMapRecord[] = [
    { attribute: EDA.board, icon: EGlyphicon.knight },
    { attribute: EDA.buy, icon: EGlyphicon["shopping-cart"] },
    {
        attribute: EDA.decision,
        icon: EGlyphicon.transfer,
        linkTextColor: `#00ffad`,
        prefix: "Could",
    },
    {
        attribute: EDA.direction,
        icon: EGlyphicon.flag,
        iconClass: styles.flag,
        linkTextColor: `gold`,
        prefix: "Someday I'll",
    },
    {
        attribute: EDA.fascination,
        icon: EGlyphicon.asterisk,
        linkTextColor: `white`,
        prefix: "Unsound:",
    },
    { attribute: EDA.fixed, icon: EGlyphicon.stop },
    { attribute: EDA.in_progress, icon: EGlyphicon.save },
    {
        attribute: EDA.important,
        linkTextColor: `gold`,
        icon: EGlyphicon["exclamation-sign"],
        iconClass: classNames(styles.important, {
            [styles.important_ifDesktop]: !IsMobileDevice(),
        }),
    },
    { attribute: EDA.indirect, icon: EGlyphicon.random },
    {
        attribute: EDA.prayer,
        prefix: `Prayer:`,
        icon: EGlyphicon.certificate,
    },
    {
        attribute: EDA.problem,
        icon: EGlyphicon.tint,
        iconClass: StyleClass(`problemAttribute`, { color: `red` }),
        linkTextColor: `coral`,
        prefix: `Cannot`,
    },
    { attribute: EDA.reading, icon: EGlyphicon.book },
    { attribute: EDA.tentative, icon: EGlyphicon["question-sign"] },
    { attribute: EDA.unclean, icon: EGlyphicon["folder-close"] },
    {
        attribute: EDA.waypoint,
        icon: EGlyphicon["map-marker"],
        linkTextColor: `yellowgreen`,
        prefix: `Could keep`,
    },
];

export function GetDreamAttributeIcon(attribute: EDA) {
    const attributeMaps = attributeMap.filter(
        (amr) => amr.attribute === attribute
    );

    if (attributeMaps.length !== 1) {
        throw new Error(
            `Cannot find a matching attribute map for the attribute '${EDA[attribute]}'`
        );
    }

    return attributeMaps[0].icon;
}

export function GetDreamAttributeTextColor(attribute: EDA) {
    const attributeMaps = attributeMap.filter(
        (amr) => amr.attribute === attribute
    );

    if (attributeMaps.length !== 1) {
        throw new Error(
            `Cannot find a matching attribute map for the attribute '${EDA[attribute]}'`
        );
    }

    return attributeMaps[0].linkTextColor;
}

export const defaultDreamPrefix = `I'd like to `;

export function GetDreamAttributePrefix(attributes: string[]) {
    const attributeName = attributes.length > 0 ? attributes[0] : null;

    if (attributeName == null || attributeName === "") {
        return defaultDreamPrefix;
    }

    const attributeMaps = attributeMap.filter(
        (amr) => EDA[amr.attribute] === attributeName
    );

    if (attributeMaps.length !== 1) {
        throw new Error(
            `Cannot find a matching attribute map for the attribute '${attributeName}'`
        );
    }

    const prefix = attributeMaps[0].prefix;
    return prefix ? prefix + " " : defaultDreamPrefix;
}

export function HasPrimaryAttribute(dream: IDream) {
    const result = dream.attributes.filter(IsPrimaryAttribute).length > 0;
    return result;
}

export function IsPrimaryAttribute(attribute: string) {
    return (
        attribute === EDA[EDA.problem] ||
        attribute === EDA[EDA.decision] ||
        attribute === EDA[EDA.direction] ||
        attribute === EDA[EDA.fascination]
    );
}
